import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoImg from 'eco-design/base/eco-img';
import ArrowTop from './ArrowTop';

const Icon = ({ className }: { className: string }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" className={className} width="24" height="25" viewBox="0 0 24 25" fill="none">
            <path
                d="M12 22.5C17.5228 22.5 22 18.0228 22 12.5C22 6.97715 17.5228 2.5 12 2.5C6.47715 2.5 2 6.97715 2 12.5C2 18.0228 6.47715 22.5 12 22.5Z"
                stroke="#757575"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M8 11.5L12 15.5L16 11.5" stroke="#757575" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default function Certified() {
    const { useLang, useState, gtm } = useGlobal();
    const { t } = useLang('costsaving-new.Certified');
    const [activeIndex, setActiveIndex] = useState(0);

    const sceneList: any[] = [
        {
            title: t('secB_scene1_title'),
            desc: [
                {
                    title: t('secB_scene1_desc_1_title'),
                    desc: t('secB_scene1_desc_1_desc'),
                },
                {
                    title: t('secB_scene1_desc_2_title'),
                    desc: t('secB_scene1_desc_2_desc'),
                },
                // {
                //     title: t('secB_scene1_desc_3_title'),
                //     desc: t('secB_scene1_desc_3_desc'),
                // },
            ],
            src: 'https://websiteoss.ecoflow.com/upload/image/1760082012635/Tough%20from%20the%20Core.jpg',
            srcPad: 'https://websiteoss.ecoflow.com/upload/image/1760088895077/H5-Frame%201612707567.jpg',
        },
        {
            title: t('secB_scene2_title'),
            desc: [
                {
                    title: t('secB_scene2_desc_1_title'),
                    desc: t('secB_scene2_desc_1_desc'),
                },
                {
                    title: t('secB_scene2_desc_2_title'),
                    desc: t('secB_scene2_desc_2_desc'),
                },
                {
                    title: t('secB_scene2_desc_3_title'),
                    desc: t('secB_scene2_desc_3_desc'),
                },
            ],
            src: 'https://websiteoss.ecoflow.com/upload/image/1760181596869/Frame%201612707571.jpg',
            srcPad: 'https://websiteoss.ecoflow.com/upload/image/1760181675607/Frame%201612707571%20(1).jpg',
        },
        {
            title: t('secB_scene3_title'),
            desc: [
                {
                    title: t('secB_scene3_desc_1_title'),
                    desc: t('secB_scene3_desc_1_desc'),
                },
                {
                    title: t('secB_scene3_desc_2_title'),
                    desc: t('secB_scene3_desc_2_desc'),
                },
                {
                    title: t('secB_scene3_desc_3_title'),
                    desc: t('secB_scene3_desc_3_desc'),
                },
            ],

            src: 'https://websiteoss.ecoflow.com/upload/image/1760090074937/Ready%20for%20the%20Worst%20Weather%20(1).jpg',
            srcPad: 'https://websiteoss.ecoflow.com/upload/image/1760088896840/H5-Frame%201612707568.jpg',
        },
        {
            title: t('secB_scene4_title'),
            desc: [
                {
                    title: t('secB_scene4_desc_1_title'),
                    desc: t('secB_scene4_desc_1_desc'),
                },
                {
                    title: t('secB_scene4_desc_2_title'),
                    desc: t('secB_scene4_desc_2_desc'),
                },
            ],
            src: 'https://websiteoss.ecoflow.com/upload/image/1760082013435/Long-Term%20Reliability%2C%20Guaranteed.jpg',
            srcPad: 'https://websiteoss.ecoflow.com/upload/image/1760088894400/H5-Frame%201612706995.jpg',
        },
    ];

    const handleClick = (item: any, index: number) => {
        setActiveIndex(index);

        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'product_detail_page',
                list_name: t('title'),
                button_name: item.title,
            });
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div
            id="cost-saving-Certified"
            className={`cost-saving-Certified pb-layout ${css['cost-saving-Certified']} GtmModuleData-section`}
            data-section-id={'power-backup-Certified'}
            data-section-title={t('title')}
        >
            <EcoSectionCommon title={t('title')} desc={t('desc')} />
            <div className="wrapper page-layout">
                <div className="wrapper-left">
                    {sceneList.map((item, index) => (
                        <>
                            <EcoImg className={` ${activeIndex === index ? 'active' : ''}`} pc={item.src} pad={item.srcPad} />
                            <div key={index} className="wrapper-left-item">
                                <div className="wrapper-left-item-title" onClick={() => handleClick(item, index)}>
                                    {item.title}
                                    <Icon className={`${activeIndex === index ? 'icon active' : 'icon'}`} />
                                    <ArrowTop className={`${activeIndex === index ? 'icon' : 'icon active'}`} />
                                </div>
                                <div className={`wrapper-left-item-desc ${activeIndex === index ? 'active' : ''}`}>
                                    {item.desc.map((item: any, index: number) => (
                                        <div key={index} className="desc-item">
                                            <div className="desc-item-title">{item.title}</div>
                                            <div className="desc-item-desc">{item.desc}</div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </>
                    ))}
                </div>
                <div className="wrapper-right">
                    <EcoImg pc={sceneList[activeIndex].src} pad={sceneList[activeIndex].srcPad} />
                </div>
            </div>
        </div>
    );
}
